export const parserMixin = {
    methods: {
        inputCurrencyParser(value) {
            const parseValue = value.toString();
            const numeric = parseValue.replace(/\D/g, "");
            return numeric.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        }
    }
};


// WEBPACK FOOTER //
// ./src/mixins/parser.js